<template>
  <div class="container-fluid">
    <!-- info box -->
    <performance-report v-if="this.$route.params.status == null" />
    <!-- info box -->
    <div class="row">
      <div class="col-12">
        <List routeName="TicketDetailsAgent" />
      </div>
    </div>
  </div>
</template>

<script>
import List from '@/components/List.vue'
import BackIcon from '@/components/BackIcon.vue'
import PerformanceReport from '../../components/PerformanceReport.vue'

export default {
  name: 'TicketsAgent',

  data() {
    return {}
  },

  watch: {},

  mounted() {
    /* let status = 'all'
    if (this.$route.params.status != undefined) {
      status = this.$route.params.status
    }
    this.loadTickets(status)
    this.status = status */
  },

  methods: {
    /*  loadTickets(status) {
      let path = '/agent/tickets?status=' + status
      let searchType = this.$route.query.searchType
      let searchTerm = this.$route.query.searchTerm
      if (searchType !== '' && searchType !== undefined) {
        path = `/agent/search-tickets?searchType=${searchType}&searchTerm=${searchTerm}`
      }

      this.spinner = true
      axios.get(path).then(res => {
        if (res.data.status == 'success') {
          this.reports = res.data
          this.label = res.data.label
          this.tickets = res.data.tickets
          this.totalTickets = res.data.totalTickets
        } else {
          //this.$swal("Ooops!", res.data.message, "error");
          this.tickets = []
        }
        this.spinner = false
      })
    }, */
    /*  searchTickets(data) {
      this.tickets = data.tickets
      this.label = data.label
      this.totalTickets = data.tickets.length
      //this.$store.state.pageTicketList = data.tickets
    } */
  },

  components: {
    List,
    // ChatAuthor,
    BackIcon,
    PerformanceReport
  }
}
</script>

<style></style>
